import { TestedServer } from '../Models/server';

export class ServerSetup {
    constructor () {
        this.servers = [
            new TestedServer('us-n1','http://n1.us.patchkit.net', '8888'),
            new TestedServer('eu-n3','http://n3.eu.patchkit.net', '8888'),
            new TestedServer('us-n2','http://n2.us.patchkit.net', '8888'),
            new TestedServer('eu-n4','http://n4.eu.patchkit.net', '8888'),
            new TestedServer('us-n3e','http://n3-east.us.patchkit.net', '8888'),
            new TestedServer('eu-n6','http://n6.eu.patchkit.net', '8888'),
            new TestedServer('in-n1','http://n1.in.patchkit.net', '8888'),
        ], // list of tested servers 
        this.downloadsPerPing = 1,  // request at once
        this.timePerTestedServer = 10000; // in milliseconds    
    }
}